import { htmlNew, htmlTagged } from '../fun-js-lib/html'
import { weatherHint } from './hint'

export function initValidateWeather () {
  getWeatherInputs().forEach(input => {
    input.addEventListener('input', validate)
  })
  validate()
}

function validate () {
  getWeatherInputs().forEach(input => {
    let valid = isValidOrEmpty(input.value)
    input.classList.toggle('is-invalid', !valid)
  })
  if (isWeatherFieldsFilledIncorrectly()) {
    setErrorHint()
  } else {
    unsetErrorHint()
  }
}

/**
 * Returns true iff some of weather fields are filled
 * but incorrect
 */
export const isWeatherFieldsFilledIncorrectly = () =>
  getWeatherInputs().some(input =>
    !isValidOrEmpty(input.value))

/**
 * @param {string} value 
 */
const isValidOrEmpty = value =>
  isValidWeather(value) || value === ''

/**
 * @param {string} str 
 */
function isValidWeather (str) {
  return str.length <= 40
}

function setErrorHint () {
  unsetErrorHint()
  let h5 = htmlNew('h5')
  h5.classList.add('text-center')
  let small = htmlNew('small')
  small.classList.add('text-danger')
  small.innerHTML = weatherHint
  h5.appendChild(small)
  container()
    .prepend(h5)
}

function unsetErrorHint () {
  htmlTagged(container(), 'h5')
    .forEach(small => small.remove())
}

export function getWeatherInputs () {
  return htmlTagged(container(), 'input')
}

function container () {
  return document.getElementById('weatherContainer')
}